import Vue from './main';
import { Checkbox, Input, Form, FormItem, Select, Option, Carousel, CarouselItem, MessageBox, Dropdown, DropdownItem, Badge, RadioGroup, Radio } from 'element-ui'
import { getLangPath } from './lib/i18n/getLang'
import Validator from './lib/mixins/validator.js'
import spanCount from './components/spans'
import request from 'axios';
// 顶部分类
import classify from './components/classify'
import store from './lib/local/cart'
import { i18n, loadLanguageAsync } from "./lib/i18n"
loadLanguageAsync('header')
loadLanguageAsync('center')
Vue.use(Checkbox);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(Badge)
Vue.use(Radio);
Vue.use(RadioGroup);
const lang = getLangPath()
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$langPath = lang
new Vue({
  i18n,
  el: '#nav',
  store: store,
  components: {
    classify,
    spanCount,
  },
  data: {
    agreeClause: false, // 是否同意条款
    loginType: 1, // 1登录 2注册 3忘记密码 4绑定邮箱
    login: {
      email: '',
      password: '',
    },
    login_loading: false,
    langList: [
      {
        value: 'cn',
        label: '简体中文'
      },
      {
        value: 'en',
        label: 'English'
      },
      {
        value: 'nl',
        label: 'Nederlands'
      }
    ],
    langText: '',
    category: false,
    loadCategory: false, //在使用时才加载分类列表
    isoneClass: false,
    showLang: false,
    showlogin: false,
    lang: '',
    showDialog: false, // 显示国家弹窗
    showSelete: false,// 显示国家列表
    countryTemp: localStorage.getItem('COUNTRY') || 'NL',
    country: localStorage.getItem('COUNTRY') || 'NL',
    countrybf: localStorage.getItem('COUNTRY') || 'NL',
    countryList: [],
    countryId: 0,
    postcode: '',
    postcodeRemark: '',
    currentCountry: [],
    defaultPostcode: '',
    classify: [],
    selectCountryDialog: false, // 选择国家弹窗
    showApp: false, // 显示下载app弹窗
    locationSearch: {}, // 获取url中的参数 应用于第三方登录后绑定邮箱
    countInterval: 0, // 发送验证邮件倒计时
    interval: null, // 储存发送邮件定时器
    localVerifyEmail: localStorage.getItem('localVerifyEmail'),
    skip_loading: false,
    categorySwiper: {}, // 分类栏滚动
    showImage: false, // 是否加载登录界面的一些图标tweede niveau
    tweeClass: [],
    category_id: '',
    category_idTop: '',
    keyword: '',
    tewClassList: [],
    selectWith: '3.3462rem',
    twoClass: [],
    oneClass: [],
    threeClass: [],
    fourClass: [],
    toptwoClass: [],
    toponeClassClass: [],
    topthreeClass: [],
    ipv4ip: '',
    ipGetCountry: '',
  },
  mixins: [Validator],
  async created() {
    if (this.$getUrlParams('keyword')) {
      this.keyword = this.$getUrlParams('keyword').keyword;
    }
    await this.fetchIPAddress()

    if (location.pathname.indexOf('/cn') >= 0) {
      localStorage.setItem('localLang', 'cn')
      this.lang = 'cn'
      this.langText = '简体中文'
    } else if (location.pathname.indexOf('/nl') >= 0) {
      localStorage.setItem('localLang', 'nl')
      this.lang = 'nl'
      this.langText = 'Nederlands'
    } else if (location.pathname.indexOf('/en') >= 0) {
      localStorage.setItem('localLang', 'en')
      this.lang = 'en'
      this.langText = 'English'
    } else {
      this.lang = 'cn'
      this.langText = '简体中文'
    }

    // if (localStorage.getItem('localLang') && this.lang !== localStorage.getItem('localLang')) {
    //   localStorage.setItem('localLang', this.lang)
    //   console.log('为真不等于', this.lang);
    // }

    if (!localStorage.getItem('localLang') && location.pathname.indexOf('/cn') >= 0 || location.pathname.indexOf('/nl') >= 0) {
      localStorage.setItem('localLang', this.lang)
    }
    // 默认
    if (!localStorage.getItem('localLang') && location.pathname.indexOf('/nl') == -1 && location.pathname.indexOf('/cn') == -1 && location.pathname.indexOf('/en') == -1) {
      localStorage.setItem('localLang', 'cn')
      const local = window.location;
      let path = local.pathname != "/" ? local.pathname : "";
      let href = `${local.origin}/cn${path}`;
      local.href = href;
    } else if (localStorage.getItem('localLang') && location.pathname.indexOf('/nl') == -1 && location.pathname.indexOf('/cn') == -1 && location.pathname.indexOf('/en') == -1) {
      const local = window.location;
      let path = local.pathname != "/" ? local.pathname : "";
      let href = `${local.origin}/${localStorage.getItem('localLang')}${path}`;
      local.href = href;
    }
    this.getLocationSearch()
    if (!window.localStorage.getItem('COUNTRY')) {
      this.changePostCode()
    }
    this.selectWith = this.lang == 'en' ? '2.8462rem' : this.lang == 'cn' ? '3.3462rem' : '4.0385rem';

  },
  mounted() {
    this.initNav()
    this.lazyImage()
  },
  watch: {
    isoneClass(newValue, onlValue) {
      document.getElementsByTagName('body')[0].style.overflow = newValue ? 'hidden' : 'initial'
    },
    loadCategory(newValue, onlValue) {
      document.getElementsByTagName('body')[0].style.overflow = newValue ? 'hidden' : 'initial'
    },
    lang(newValue, onlValue) {
      this.langList.forEach(e => {
        if (e.value == newValue) {
          this.langText = e.label
        }
      })

    },
    category_id(newvalue, oldvalue) {
      if (oldvalue && oldvalue != newvalue) {
        // console.log(document.getElementById('t' + oldvalue), '222222', newvalue, oldvalue);
        document.getElementById('t' + oldvalue).style.color = '#333'
        document.getElementById('t' + oldvalue).style.borderBottom = '5px transparent solid'
      }
    },
    category_idTop(newvalue, oldvalue) {
      if (oldvalue && oldvalue != newvalue) {
        // console.log(document.getElementById('l' + oldvalue), '11111', newvalue, oldvalue);
        document.getElementById('l' + oldvalue).style.color = '#333'
        document.getElementById('l' + oldvalue).style.background = '#fff'
        document.getElementById('l' + oldvalue).style.fontWeight = '400'
      }
    }
  },
  methods: {
    // 个人中心
    goUserinfo() {

    },
    // 初始化左侧导航栏的功能
    initNav() {
      if (this.$refs.sidebar) {
        this.$refs.sidebar.addEventListener('mouseenter', e => {
          e.target.dataset.showSidebar = 'true'
          this.showImage = true
        }, { passive: true })
        this.$refs.sidebar.addEventListener('mouseleave', e => {
          if (e.toElement || e.y > document.documentElement.clientHeight - 2 || e.y < 1) {
            e.target.dataset.showSidebar = 'false'
          }
        }, { passive: true })
      }
      this.$json.get('countries').then(res => {
        if (res.ret) {
          if (!localStorage.getItem('COUNTRY')) {
            fetch('/ip_get_country/' + this.ipv4ip)
              .then(response => response.json())
              .then(data => {
                res.data.forEach(el => {
                  if (el.code == data.data) {
                    this.countrybf = data.data
                    this.country = data.data
                    localStorage.setItem('COUNTRY', data.data)
                    localStorage.setItem('COUNTRYID', el.id)
                  }
                })
                console.log('获取到的国家为：', data.data)
              })
              .catch(error => {
                console.error('Error fetching user data:', error);
              });
          }
          this.countryList = res.data
          this.countryId = res.data[0].id
          this.defaultPostcode = res.data.filter(item => item.code === 'NL')[0].postcode
          this.switchCountry()
        }
      })
    },
    // 为部分图片实现懒加载
    lazyImage() {
      let footerElement = document.querySelector('.payment-method')
      if (!footerElement) return
      let io = new IntersectionObserver((e) => {
        let ele = e[0]
        if (ele.intersectionRatio || window.pageYOffset > 4250) {
          if (ele.target.className === 'payment-method') {
            for (let item of ele.target.children) {
              let img = item.firstElementChild || item
              if (!img.hasAttribute('lazyImage')) return
              if (img.tagName === "IMG") {
                img.src = img.getAttribute('lazyImage')
                img.removeAttribute('lazyImage')
                img.style.opacity = '1'
              } else {
                img.src = img.getAttribute('lazyImage')
                img.removeAttribute('lazyImage')
                img.style.opacity = '1'
              }
            }
            io.unobserve(footerElement)
          }
        }
      })
      io.observe(footerElement)
    },
    submitForms(e) {
      console.log(1111111111, this.keyword);
      const route = window.location
      const localLang = localStorage.getItem('localLang')
      let url
      url = `${route.origin}${'/' + localLang}/search?keyword=${this.keyword}`
      console.log(url);
      route.href = url
    },
    removeUserInfo() {
      window.sessionStorage.removeItem('userInfo')
    },
    // 分类滚动
    categoryToLeft(e) {
      if (!this.categorySwiper.container || !this.categorySwiper.maxStep || this.categorySwiper.step <= 0) return
      if (this.categorySwiper.step <= 1) {
        this.categorySwiper.step--
        this.categorySwiper.goodsWidth = 0
      } else {
        this.categorySwiper.step--
        this.categorySwiper.goodsWidth += this.categorySwiper.visibleCount * this.categorySwiper.distance
      }
    },
    categoryToRight(e) {
      if (this.categorySwiper.container) {
        if (!this.categorySwiper.maxStep || this.categorySwiper.step >= this.categorySwiper.maxStep) return
        if (this.categorySwiper.step === this.categorySwiper.maxStep - 1) {
          this.categorySwiper.step++
          // 直接滚动到最后
          this.categorySwiper.goodsWidth = -this.categorySwiper.totalCount * this.categorySwiper.distance + this.categorySwiper.fatherWidth + 10
        } else if (this.categorySwiper.step < this.categorySwiper.maxStep) {
          this.categorySwiper.step++
          this.categorySwiper.goodsWidth -= this.categorySwiper.visibleCount * this.categorySwiper.distance
        }
      } else {
        const container = document.querySelector('.category-list')
        const totalCount = container.children.length
        const father = document.querySelector('.category')
        const fatherWidth = father.clientWidth - parseInt(getComputedStyle(father)['padding-left']) * 2
        const item = container.querySelector('.calssify-item')
        const distance = item.clientWidth + 10
        const visibleCount = Math.floor(container.clientWidth / distance)
        const maxStep = Math.ceil(totalCount / visibleCount) - 1
        this.categorySwiper = {
          totalCount,
          container,
          item,
          distance,
          visibleCount,
          maxStep,
          step: 0,
          fatherWidth,
          goodsWidth: 0
        }
        this.categoryToRight(e)
      }
    },
    categoryMouseenterTop(item) {
      if (item && item.child.length > 0) {
        this.category_idTop = item.category_id
        document.getElementById('l' + item.category_id).style.color = '#333'
        document.getElementById('l' + item.category_id).style.background = '#FFF0E5'
        document.getElementById('l' + item.category_id).style.fontWeight = 'bold'
        let cardList = item.child;
        let oneClass = []
        let twoClass = []
        let threeClass = []
        if (cardList.length >= 1) {
          oneClass.push(cardList[0])
        }
        if (cardList.length >= 2) {
          twoClass.push(cardList[1])
        }
        if (cardList.length >= 3) {
          threeClass.push(cardList[2])
          let num = 3
          cardList.forEach((e, index) => {
            if (cardList[index + num]) {
              oneClass.push(cardList[index + num])
            }
            if (cardList[index + num + 1]) {
              twoClass.push(cardList[index + num + 1])
            }
            if (cardList[index + num + 2]) {
              threeClass.push(cardList[index + num + 2])
            }
            num = num + 2
          })
        }
        this.toponeClassClass = [oneClass]
        this.toptwoClass = [twoClass]
        this.topthreeClass = [threeClass]
      }
      this.showSelete = false;
      this.showlogin = false;
      this.category = false;
      this.loadCategory = false;
      this.isoneClass = true;
    },
    // 鼠标移入分类选项
    categoryMouseenter(item) {
      if (item && item.child.length > 0) {
        this.category_id = item.category_id
        document.getElementById('t' + item.category_id).style.color = '#333'
        document.getElementById('t' + item.category_id).style.borderBottom = '5px #FF7802 solid'
        // document.getElementById('t' + item.category_id).style.fontWeight = 'bold'
        let cardList = item.child;
        let newCardList = [];
        // for (var i = 0; i < cardList.length; i += 9) {
        //   newCardList.push(cardList.slice(i, i + 9));
        // }
        let oneClass = []
        let twoClass = []
        let threeClass = []
        let fourClass = []
        if (cardList.length >= 1) {
          oneClass.push(cardList[0])
        }
        if (cardList.length >= 2) {
          twoClass.push(cardList[1])
        }
        if (cardList.length >= 3) {
          threeClass.push(cardList[2])
        }
        if (cardList.length >= 4) {
          fourClass.push(cardList[3])
          let num = 4
          cardList.forEach((e, index) => {
            if (cardList[index + num]) {
              oneClass.push(cardList[index + num])
            }
            if (cardList[index + num + 1]) {
              twoClass.push(cardList[index + num + 1])
            }
            if (cardList[index + num + 2]) {
              threeClass.push(cardList[index + num + 2])
            }
            if (cardList[index + num + 3]) {
              fourClass.push(cardList[index + num + 3])
            }
            num = num + 3
          })
        }
        this.oneClass = [oneClass]
        this.twoClass = [twoClass]
        this.threeClass = [threeClass]
        this.fourClass = [fourClass]
        // this.tweeClass = [cardList]
      }
      this.showSelete = false;
      this.category = true;
      this.loadCategory = true;
    },
    getUrl(id, search) {
      // 决定用location
      const route = window.location
      const localLang = localStorage.getItem('localLang')
      let url
      if (!search) {
        url = `${route.origin}${localLang != 'en' ? '/' + localLang : ''}/category/${id}`
      } else {
        url = `${route.origin}${localLang != 'en' ? '/' + localLang : ''}/category/${id}?${search}`
      }
      route.href = url
    },
    gologin() {
      const route = window.location;
      const localLang = localStorage.getItem('localLang');
      console.log(localLang, 'localLang');
      let url = `${route.origin}${localLang != 'en' ? '/' + localLang : ''}/login`
      route.href = url
    },
    // 跳转到分类页
    skip(id) {
      this.getUrl(id)
    },
    hideloadl() {
      this.isoneClass = false
      document.getElementById('l' + this.category_idTop).style.color = '#333'
      document.getElementById('l' + this.category_idTop).style.background = '#fff'
      document.getElementById('l' + this.category_id).style.fontWeight = '400'
    },
    classTop() {
      this.isoneClass = true;
      this.loadCategory = false
      this.showSelete = false;
    },
    // 隐藏分类
    hideload() {
      this.loadCategory = false
      if (this.category_id) {
        document.getElementById('t' + this.category_id).style.color = '#333'
        document.getElementById('t' + this.category_id).style.borderBottom = '5px transparent solid'
      }
    },
    // 鼠标移开分类选项
    categoryMouseleave(e) {
      if (!e.toElement) return
      let isLeave = Array.from(e.toElement.classList).some(item => ['popper__arrow', 'el-dropdown-menu', 'el-dropdown-menu__item'].includes(item))
      if (isLeave) {
        e.toElement.closest('ul.el-dropdown-menu').onmouseleave = event => {
          let isout = Array.from(event.toElement.classList).some(item => ['el-category', 'classify-list', 'el-carousel__item', 'el-icon-arrow-left', 'el-icon-arrow-right'].includes(item))
          this.category = isout
        }
      } else {
        this.category = false
      }
    },
    // 获取url上面的参数
    getLocationSearch() {
      this.locationSearch = window.location.search.slice(1).split('&').reduce((pre, cur) => {
        if (!cur) return pre
        let arr = cur.split('=')
        pre[arr[0]] = arr[1]
        return pre
      }, {})
      if (this.locationSearch.email && !this.locationSearchuuid) {
        // 第三方登录 已自动登录
        this.removeUserInfo()
      }
      // if(this.locationSearch.uuid) this.loginType = 4
    },
    // 跳转到订单列表
    toOrderList(statusid) {
      window.location.href = statusid ? `/${lang}user/orderlist?status=${statusid}` : `/${lang}user/orderlist`;
    },
    // 跳转到充值界面
    // skip() {
    //   window.location.href = `/${lang}user/recharge`;
    // },
    // 获取待支付，待收货，退款订单数量
    getOrderTotal() {
      store.state.orderCountPromise.then(res => {
        this.ToBePaid = res.data.pay_wait,
          this.ToBeReceived = res.data.confirm_good_wait,
          this.Refund = res.data.refund_exchange
      })
    },
    // 点击登录/注册/其它
    loginAccount() {
      switch (this.loginType) {
        case 1:
          this.userLogin()
          break;
        case 2:
          this.userRegister()
          break;
        case 3:
          this.forgetPasswds()
          break;
      }
    },
    // 第三方登录后需要绑定邮箱 传了type表示跳过绑定,则不需要传邮箱和密码
    bindingEmail(type) {
      let promise
      if (type) {
        this.skip_loading = true
        promise = this.$json.post('user_socialite', { uuid: this.locationSearch.uuid })
      } else {
        if (!this.login.email.trim() || !this.login.password.trim()) {
          return this.$message.error(this.$t(!this.login.email.trim() ? 'login.emailMessage' : 'login.passwdMessage'));
        }
        this.login_loading = true
        promise = this.$json.post('user_socialite', { ...this.login, uuid: this.locationSearch.uuid })
      }
      promise.then(res => {
        if (res.ret) {
          this.removeUserInfo()
          this.$message.success(res.msg)
          window.location.href = window.location.origin + window.location.pathname
        }
      }).finally(() => {
        this.login_loading = false
        this.skip_loading = false
      })
    },
    // 登录后获取用户信息
    getUserInfo() {
      store.getters.computedLoginPromise.then(res => {
        this.userInfo = { ...res.data }
        if (this.userInfo.verify_email) {
          this.localVerifyEmail = ''
          window.localStorage.removeItem('localVerifyEmail')
        }
      })
    },
    // 跳过验证邮箱
    skipBinding() {
      window.localStorage.removeItem('localVerifyEmail')
      window.location.href = window.location.origin + window.location.pathname
    },
    // 忘记密码
    forgetPasswds() {
      if (!this.login.email) return this.$message.warning(this.$t('login.emailNotNull'))
      this.login_loading = true
      this.$json.get('reset_password_email', {
        params: {
          email: this.login.email
        }
      }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        })
      }).finally(() => {
        this.login_loading = false
      })
    },
    // 注册
    userRegister() {
      if (!this.login.email) return this.$message.warning(this.$t('login.emailNotNull'))
      if (!this.login.password) return this.$message.warning(this.$t('login.passwdMessage'))
      if (!this.agreeClause) return this.$message.warning(this.$t('login.agree'))
      let params = {
        ...this.login,
        source: 'PC'
      }
      this.login_loading = true
      this.$json.post('register', params).then(res => {
        if (res.ret) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          window.localStorage.setItem('localVerifyEmail', this.login.email)
          window.location.reload()
          this.removeUserInfo()
        }
      }).finally(() => {
        this.login_loading = false
      })
    },
    // 前往用户中心
    goUser() {
      window.location.href = `/${lang}user`;
    },
    // 退出登录
    logout() {
      this.$confirm(this.$t('suretologout'), this.$t('button.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
        customClass: 'confirm-logout'
      }).then(() => {
        this.$json.get('logout').then(() => {
          store.commit('CART_CHANGE', 0)
          store.commit('DEL_ALL_CHECKED')
          window.location.href = `/${this.$langPath}`
          window.sessionStorage.removeItem('userInfo')
          window.localStorage.removeItem('email')
          window.sessionStorage.removeItem('orderCount')
          window.sessionStorage.removeItem('favoriteList')
        })
      })
    },
    gourl(value) {
      if (value == 'logout') {
        this.logout()
        return
      }
      const route = window.location;
      const localLang = localStorage.getItem('localLang');
      let url = `${route.origin}${localLang != 'en' ? '/' + localLang : ''}/${value}`
      route.href = url
    },
    // 收藏列表
    goWish() {
      window.location.href = `/${lang}user/wishlist`
    },
    // 前往购物车
    goCart() {
      window.location.href = `/${lang}cart`
    },
    skipHome() {
      window.location.href = `/${lang}`
    },
    changeLang(lang) {
      this.selectWith = lang == 'en' ? '2.8462rem' : lang == 'cn' ? '3.3462rem' : '4.0385rem';
      let pathName = location.pathname
      if (this.localLang === 'en') {
        pathName = `/${lang}${/^\/en/.test(pathName) ? pathName.slice(3) : pathName}`
      } else {
        if (lang === 'en') {
          pathName = pathName.replace(`/${this.localLang}`, '/en')
        } else {
          pathName = pathName.replace(`/${this.localLang}`, `/${lang}`)
        }
      }
      window.localStorage.setItem('localLang', lang);
      window.location.href = `${window.location.origin}${pathName}${window.location.search}`
    },
    switchCountry() {
      // this.showDialog = true
      let code = localStorage.getItem('COUNTRY')
      let postcode = localStorage.getItem('POSTCODE')
      let list = this.countryList.map(item => {
        let id = item.id
        let code = item.code
        let postcode = item.postcode
        return {
          id,
          code,
          postcode
        }
      })
      if (code) {
        this.countryId = list.filter(item => item.code === code)[0].id
      }
      if (postcode) {
        this.postcode = postcode
      }
      this.countryId && this.selectCountry(this.countryId)
    },
    showcountry() {
      this.showSelete = true
      this.loadCategory = false
      this.category_id = ''
    },
    showlogins() {
      this.showlogin = true
      this.showLang = false;
      this.showSelete = false;
      this.loadCategory = false;
      this.isoneClass = false
    },
    showlanghs() {
      this.showLang = true;
      this.showSelete = false;
      this.loadCategory = false;
      this.isoneClass = false
    },
    hidecountry() {
      this.showSelete = false
      this.countrybf = localStorage.getItem('COUNTRY') || 'NL';
    },
    hidelang() {
      this.showLang = false
    },
    hidelogin() {
      this.showlogin = false
    },
    // 选择国家
    changePostCode() {
      // this.showSelete = !this.showSelete
      this.loadCategory = false
      if (this.showSelete) {
        this.$json.get('countries').then(res => {
          if (res.ret) {
            this.countryList = res.data
            this.countryId = res.data[0].id
            this.defaultPostcode = res.data.filter(item => item.code === 'NL')[0].postcode
            this.switchCountry()
          }
        })
      }
    },
    // 选择国家
    selectCountry(val) {
      this.currentCountry = this.countryList.map(item => {
        return {
          id: item.id,
          postcode: item.postcode,
          code: item.code,
          prompt: item.prompt
        }
      }).find(item => item.id === val)
      this.postcodeRemark = this.currentCountry.prompt
      this.countrybf = this.currentCountry.code
      localStorage.setItem('COUNTRY', this.currentCountry.code)
      localStorage.setItem('COUNTRYID', this.currentCountry.id)
      // console.log(this.currentCountry);
    },
    // 关闭国家弹窗
    onCountryDialogClose() {
      this.showDialog = false
      if (!localStorage.getItem('POSTCODE')) {
        localStorage.setItem('POSTCODE', this.defaultPostcode) // 设置一个默认国家
      }
      if (!localStorage.getItem('COUNTRY')) {
        localStorage.setItem('COUNTRY', 'NL') // 设置一个默认国家
      }
      if (this.countryTemp !== this.country) {
        this.countryTemp = this.country
      }
    },
    // 确定
    onCountryConfirm() {
      if (!this.currentCountry.id) return this.$message.error(lang ? '请选择国家' : 'Please select a country')
      if (!this.postcode) return this.$message.error(lang ? '请输入邮编' : 'Enter Zip Code')
      this.showSelete = false;
      this.$json.get(`countries/${this.currentCountry.id}/${this.postcode}`).then(res => {
        if (res.ret) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.showDialog = false
          this.country = this.countryTemp
          this.countrybf = this.countryTemp
          localStorage.setItem('COUNTRY', this.currentCountry.code)
          localStorage.setItem('POSTCODE', this.postcode)
          // 这个cid鬼知道有没有用 还是别删了
          localStorage.setItem('CID', res.data)
          const cid = res.data
          document.cookie = `clientpostcodeid=${cid}; path=/`;
          // 国家id 会被放在请求头和cookie中
          localStorage.setItem('COUNTRYID', this.countryId)
          document.cookie = `countriesId=${this.countryId}; path=/`;
          // 重置请求
          // const cid = countryObj[this.country].id
          // 将 cid 存到 cookie 中
          const href = window.location.href;
          window.location.replace(href);
        }
      })
    },
    // 发送验证邮箱
    reSend() {
      if (this.countInterval) return
      this.login_loading = true
      this.$json.post(`check_mail`, {
        email: this.userInfo.email
      }).then(res => {
        if (res.ret) {
          this.$message.success(res.msg)
          this.countDown()
        }
      }).finally(() => this.login_loading = false)
    },
    // 发送验证邮件倒计时
    countDown() {
      this.countInterval = 59
      const that = this
      this.interval = setInterval(() => {
        that.countInterval--
        if (!that.countInterval) {
          clearInterval(that.interval)
        }
      }, 1000);
    },
    async fetchIPAddress() {
      try {
        const savedIPAddress = localStorage.getItem('localIPAddress');
        if (savedIPAddress && savedIPAddress != undefined) {
          this.ipv4ip = savedIPAddress;
          // console.log(savedIPAddress, 'Ip');
        } else {
          const response = await fetch('https://api.ipify.org?format=json');
          const data = await response.json();
          // console.log(data, 'IpASSS');
          this.ipv4ip = data.ip;
          localStorage.setItem('localIPAddress', this.ipv4ip);
        }
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    },
  },
  computed: {
    myLang() {
      return lang
    },
    localLang() {
      return localStorage.getItem('localLang') || 'en'
    },
    ToBePaid() {
      return store.state.orderCount && store.state.orderCount.pay_wait
    },
    ToBeReceived() {
      return store.state.orderCount && store.state.orderCount.confirm_good_wait
    },
    Refund() {
      return store.state.orderCount && store.state.orderCount.refund_exchange
    },
    userInfo() {
      if (!store.state.isLogin) return {};
      if (store.state.isLogin.verify_email) {
        this.localVerifyEmail = ''
        window.localStorage.removeItem('localVerifyEmail')
      }
      return store.state.isLogin
    }
  }
})

new Vue({
  i18n,
  el: '#navs',
  data: {
    isicongl: null,
    iconList: [{
      url: 'wechaticon',
      active: 'wechaticonactive'
    }, {
      url: 'xhsicon',
      active: 'xhsiconactive'
    }],
    iconListright: [{
      url: 'paywechat',
      active: 'paywechatactive'
    }, {
      url: 'payAil',
      active: 'payAilactive'
    }, {
      url: 'payidea',
      active: 'payideaactive'
    }],
    showAppurl: '',
  },
  methods: {
    showiconApp(type) {
      this.showAppurl = type
    },
    hiddeiconApp() {
      this.showAppurl = null
    },
    showicon(i,) {
      this.isicongl = i
    },
    hideicon() {
      this.isicongl = null
    },
  }

})
export { store }



// WEBPACK FOOTER //
// ./resources/js/header.js